export const CHECKOUT_MULTI_STEP_FLAG = 'checkout-multi-step-flow';
export const CHECKOUT_REARRANGE_STEPS_FLAG = 'checkout-rearrange-steps-flow';
export const NCCT_STEPS_FLAG = 'checkout-ncct-steps-flow';
export const BUY_NOW_WITH_DISCOUNT = 'early-signup';
export const VERIFY_ACCOUNT = 'checkout-ncct-verify-account-required';
export const ROI_SIGNUP_PAGE = 'checkout-roi-signup-page';
